// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"91445bda","513":"4dcec6cd","639":"ee1c9d2f","770":"17d736c0","803":"721a56ab"}[chunkId] + ".chunk.js";
};